import {IPlatformApiProvider} from '@shared/services/platform-api-provider';
import {Api} from '@shared/constants/common-field.constants';

export class DataMappingApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/data-mapping')) {
      return Api.FileStoreApi;
    }
    return '';
  }
}
